import { render, staticRenderFns } from "./entity-project-rules-modal.vue?vue&type=template&id=64ced649"
import script from "./entity-project-rules-modal.vue?vue&type=script&lang=js"
export * from "./entity-project-rules-modal.vue?vue&type=script&lang=js"
import style0 from "./entity-project-rules-modal.vue?vue&type=style&index=0&id=64ced649&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports